import PropTypes from 'prop-types';
import CssClassMixin from '../../mixins/css_class_mixin.jsx';

var createClass = require('create-react-class');

window.InputError = createClass({
  mixins: [CssClassMixin],

  propTypes: {
    errors: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
  },

  getDefaultProps: function() {
    return {
      errors: [],
      themeClassKey: 'input.error.hint'
    };
  },

  render: function() {
    return (
      <span className={this.className()}>
        {this.errorMessages()}
      </span>
    );
  },

  errorMessages: function() {
    var errors = this.props.errors;
    var errorMessage = '';

    if (!Array.isArray(errors)) {
      errors = [errors];
    }

    for (var i = 0; i < errors.length; i++) {
      var error = errors[i];
      errorMessage += error + ' / ';
    }

    return errorMessage.replace(/[\/\s]*$/, '');
  }
});
